<script lang="ts">
  // Accepts any of the formats users tend to paste:
  //   https://drive.google.com/file/d/<ID>/view
  //   https://drive.google.com/file/d/<ID>/preview
  //   https://drive.google.com/open?id=<ID>
  //   <ID> alone
  //   Loom: https://www.loom.com/share/<ID>
  //   YouTube: https://youtu.be/<ID>  or  https://www.youtube.com/watch?v=<ID>

  export let src: string;

  function normalise(input: string): string {
    const s = input.trim();
    // Loom
    const loom = s.match(/loom\.com\/share\/([A-Za-z0-9]+)/);
    if (loom) return `https://www.loom.com/embed/${loom[1]}`;
    // YouTube
    const yt1 = s.match(/youtu\.be\/([A-Za-z0-9_-]+)/);
    if (yt1) return `https://www.youtube.com/embed/${yt1[1]}`;
    const yt2 = s.match(/youtube\.com\/watch\?v=([A-Za-z0-9_-]+)/);
    if (yt2) return `https://www.youtube.com/embed/${yt2[1]}`;
    // Google Drive
    const dm = s.match(/drive\.google\.com\/file\/d\/([A-Za-z0-9_-]+)/);
    if (dm) return `https://drive.google.com/file/d/${dm[1]}/preview`;
    const dq = s.match(/drive\.google\.com\/open\?id=([A-Za-z0-9_-]+)/);
    if (dq) return `https://drive.google.com/file/d/${dq[1]}/preview`;
    // Already an embed URL.
    if (/^https?:\/\//.test(s)) return s;
    // Bare ID -> assume Drive.
    return `https://drive.google.com/file/d/${s}/preview`;
  }

  $: embedUrl = normalise(src);
</script>

<div class="panel overflow-hidden">
  <div class="aspect-video bg-bg">
    <iframe
      src={embedUrl}
      title="Embedded video"
      class="w-full h-full"
      allow="autoplay; encrypted-media; fullscreen"
      allowfullscreen
      loading="lazy"
      referrerpolicy="strict-origin-when-cross-origin"
    ></iframe>
  </div>
</div>
